import OfferMarker from './OfferMarker';

export default OfferMarker;
